import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../theme';
import { InfoIcon } from './Tooltip';
import TokenStack from './TokenStack';
import { useIsMobile } from '../useMediaQuery';

export default function StatCard({ label, value, sub, accent = "green", tooltip, onClick, tokens }) {
  const { colors } = useTheme();
  const isMobile = useIsMobile();

  const ACCENT = {
    green:  { color: colors.green, bg: colors.greenBg, border: colors.greenBorder },
    gold:   { color: colors.gold, bg: colors.goldBg, border: colors.goldBorder },
    coral:  { color: "#E8471A", bg: colors.surface, border: "#F0B8A8" },
  };

  const a = ACCENT[accent] || ACCENT.green;

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      onClick={onClick}
      style={{
        background: colors.surface,
        borderRadius: 12,
        padding: isMobile ? "16px 16px" : "20px 24px",
        boxShadow: `0 1px 4px ${colors.shadow}`,
        border: `1px solid ${a.border}`,
        flex: isMobile ? 'none' : 1,
        minWidth: isMobile ? 'auto' : 200,
        width: isMobile ? '100%' : 'auto',
        transition: "background-color 0.3s ease, border-color 0.3s ease",
        cursor: onClick ? "pointer" : "default",
      }}>
      <div style={{
        fontFamily: "'IBM Plex Mono', monospace",
        fontSize: 10,
        color: colors.labelLight,
        letterSpacing: 1.5,
        textTransform: "uppercase",
        marginBottom: 8,
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        gap: 5,
      }}>
        {label}
        {tooltip && <InfoIcon text={tooltip} position="top" colors={colors} />}
      </div>
      <div style={{
        fontFamily: "'DM Serif Display', serif",
        fontSize: 26,
        color: a.color,
        marginBottom: 4,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
      }}>
        {tokens && <TokenStack tokens={tokens} size={24} />}
        {value}
      </div>
      {sub && (
        <div style={{
          fontFamily: "'IBM Plex Mono', monospace",
          fontSize: 11,
          color: colors.labelMuted,
        }}>
          {sub}
        </div>
      )}
    </motion.div>
  );
}
